exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-signup-my[data-v-63829170]{display:flex;flex-direction:column}\n", ""]);

